// extracted by mini-css-extract-plugin
module.exports = {"card":"cardLink_card__2v7dw","chevron":"cardLink_chevron__22jFX","iconCol":"cardLink_iconCol__3EWVn"};